import { Box, Text } from '@chakra-ui/react'
import React from 'react'
import { FaSearch } from 'react-icons/fa'
import Input from './Input'

export default function SearchComponent({SearchText, setSearchText,ProductName, productShelfId, Category, Keywords}) {
  return (
    <Box mt="12px">
    <Input leftIcon={<FaSearch />} iconColor="black" labelBg='#fff' label='Search' id="search" type='text' value={SearchText} val={SearchText != "" ? true : false} onChange={setSearchText} />
    <Text fontWeight={"600"} fontSize={"12px" } pt="5px">Search by: <Box fontWeight={"400"} as="span"> {Keywords}</Box> </Text>
</Box>
  )
}
